import Repository from '@/repositories/Repository'
import WeatherWarning2 from '@/models/WeatherWarning2'

// R08気象警報注意報API（app2）
// 設定したエリアの気象警報注意報を取得する
class WeatherWarning2Repository extends Repository {
  constructor() {
    super('/weather-warning2')
  }

  async get(areaCode: string) {
    const attributes = await super._get(undefined, areaCode)

    return new WeatherWarning2(attributes)
  }
}

export default WeatherWarning2Repository
